export const errorMessages = {
  errors: {
    password: {
      required: 'Enter current password',
    },
  },
};
